import React from 'react';
import { formLabelClass } from './formFieldClass';

/**
 * Thin wrapper for labelled form fields with optional inline error.
 */
export default function FormField({ id, label, error, children, className = '', labelClassName }: any) {
  return (
    <div className={className}>
      {label != null && label !== '' ? (
        <label htmlFor={id} className={labelClassName ?? formLabelClass}>
          {label}
        </label>
      ) : null}
      {children}
      {error ? (
        <p className="mt-1.5 text-sm text-red-400" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
